import React, { useCallback, useEffect, useState } from "react";

import styled from "@emotion/styled";

import CsHistoryList from "@/components/CsHistoryList";
import Modal from "@/components/Modal";
import { loadCsHistoryByDelivery } from "@/lib/csHistory";
import { useCsesStore, useDeliveriesStore, useLoadingStore } from "@/stores/hooks";

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  }

  &.modal .modal-header .close {
    padding: 5px;
  }
`;

const Header = styled(Modal.Header)`
  padding: 14px 20px;
  border-bottom: 1px solid #eee;

  .close {
    margin: 0;
    font-size: 16px;
    color: #888;
  }
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  font-size: 15px;
  font-weight: 800;
  margin: 0;
  color: #2b2b2b;
`;

const Period = styled.span`
  font-size: 12px;
  color: #767676;
  font-weight: 400;
`;

const Body = styled(Modal.Body)`
  padding: 18px 20px;
  max-height: 70vh;
`;

export default function CsListModal({ bookId, delivery }) {
  const { fetchByBookId } = useCsesStore();
  const { fetchByIdOnTheFly } = useDeliveriesStore();
  const { startLoading, finishLoading } = useLoadingStore();
  const [cses, setCses] = useState([]);
  const [period, setPeriod] = useState({ createdAtFrom: "", createdAtTo: "" });

  const loadCses = useCallback(async () => {
    if (!bookId) {
      return;
    }

    try {
      startLoading();
      const { range, rows } = await loadCsHistoryByDelivery({
        bookId,
        delivery: delivery?.bookId === bookId ? delivery : undefined,
        fetchByIdOnTheFly,
        fetchByBookId,
      });
      setPeriod(range);
      setCses(rows);
    } catch (e) {
      window.alert(`CS 목록을 불러오는데 실패했습니다: ${e.message}`);
    } finally {
      finishLoading();
    }
  }, [
    bookId,
    delivery,
    fetchByBookId,
    fetchByIdOnTheFly,
    finishLoading,
    startLoading,
  ]);

  useEffect(() => {
    loadCses();
  }, [loadCses]);

  return (
    <StyledModal>
      <Header>
        <TitleWrap>
          <Title>연결된 CS 내역 · {bookId}</Title>
          {period.createdAtFrom && period.createdAtTo && (
            <Period>
              {period.createdAtFrom} ~ {period.createdAtTo}
            </Period>
          )}
        </TitleWrap>
      </Header>
      <Body>
        <CsHistoryList cses={cses} />
      </Body>
    </StyledModal>
  );
}
